import React, {
  createContext, useMemo, useState,
} from 'react';

interface URLContextProps {
  categoryId: string
  setCategoryId: (id:string) => void
}

export const URLContext = createContext<URLContextProps>({
  categoryId: '',
  setCategoryId: () => {},
});

interface Props {
  children: JSX.Element
}

const URLContextProvider:React.FC<Props> = (props: Props) => {
  const { children } = props;
  const [categoryId, setCategoryId] = useState('');

  const value = useMemo(() => ({
    categoryId,
    setCategoryId,
  }), [categoryId]);

  return <URLContext.Provider value={value}>{children}</URLContext.Provider>;
};

export default URLContextProvider;
